import { IAppServices } from '../domain/slide-app/core/interfaces/app-service.interface';
import { IInfrastructureBase, AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';

export abstract class AppServices implements IAppServices {
    protected infrastructureService: IInfrastructureBase;

    protected constructor() {
        this.infrastructureService = this.newInfrastructureService();
        this.infrastructureService.init();
    }

    public getInfrastructureService(): IInfrastructureBase {
        return this.infrastructureService;
    }

    public init(): void {
    }

    public getEntryType(): AppEntryType {
        return this.infrastructureService.getEntryType();
    }

    protected abstract newInfrastructureService(): IInfrastructureBase;
}

